// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { Auth0Provider } from "@auth0/auth0-react";

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   // <React.StrictMode>
//   <Auth0Provider
//     domain="asbjornogmagnea.eu.auth0.com"
//     clientId="BLWKEYr7GvkrBh5ltHqew9onjiYPjtK3"
//     authorizationParams={{ redirect_uri: window.location.origin }}
//   >
//     <App />
//   </Auth0Provider>
//   // {/* </React.StrictMode> */}
// );

// reportWebVitals();

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Auth0ProviderWithRedirectCallback = ({ children }) => {
  const navigate = useNavigate();

  return (
    <Auth0Provider
      domain="asbjornogmagnea.eu.auth0.com"
      clientId="BLWKEYr7GvkrBh5ltHqew9onjiYPjtK3"
      authorizationParams={{ redirect_uri: window.location.origin }}
      onRedirectCallback={(appState) => {
        navigate(appState?.returnTo || "/");
      }}
    >
      {children}
    </Auth0Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Auth0ProviderWithRedirectCallback>
      <App />
    </Auth0ProviderWithRedirectCallback>
  </BrowserRouter>
);

reportWebVitals();